<template>
  <div class="register-container">
    <Personal action="forget" ref="personal">
      <template #header>
        <header class="title">忘记密码</header>
      </template>
      <template #footer="{ user }">
        <div class="input-container">
          <button class="register-btn" @click="changePassword(user)">确认</button>
        </div>
        <div class="input-container">
          <a class="tip" href="/">已有账号，立即登录</a>
        </div>
      </template>
    </Personal>
  </div>
</template>
<script>
import PersonalForget from "@/components/PersonalForget";
import { fetchUpdatePassword } from "@/api/user";
import { mapMutations } from "vuex";
import todoMixin from "@/mixins/todoMixin";
import { checkParam } from "@/utils";
export default {
  name: "ForgetPassword",
  data() {
    return {
      role: "",
      platform: "",
    };
  },
  mixins: [todoMixin],
  components: {
    Personal:PersonalForget,
  },
  created() {
    const { role = "", platform = "" } = this.$route.query;
    this.role = role;
    this.platform = platform;
    console.log(this.$route.query);
    
  },
  methods: {
    ...mapMutations("user", ["SET_DATA"]),
    async changePassword(user) {
      const { phone, msgCode:code, password:newPwd, psdConfirm:confirmPwd } = user;
      if (!phone) {
        this.$message({
          message: "请输入手机号",
          type: "error",
        });
        return false;
      }
      if(phone){
        const { status,message } =  checkParam('phone').execute(phone)
        if (!status) {
          this.$message({ message, type: "error" });
          return
        }
      }
      if (!code) {
        this.$message({
          message: "请输入验证码",
          type: "error",
        });
        return false;
      }
      if (!newPwd) {
        this.$message({
          message: "请输入新密码",
          type: "error",
        });
        return false;
      }
      if (newPwd.length < 6) {
        this.$message({
          message: "密码长度不能低于6位，请补全",
          type: "error",
        });
        return;
      }
      if (!confirmPwd) {
        this.$message({
          message: "请输入确认新密码",
          type: "error",
        });
        return false;
      }
      if (newPwd !== confirmPwd) {
        this.$message({
          message: "两次密码不一致",
          type: "error",
        });
        return false;
      }
      const loadingInstance = this.$loading();
      fetchUpdatePassword({
        code: code,
        phone: phone,
        password: newPwd,
      })
        .then((res) => {
          const { code, msg } = res;
          if (code === 0) {
            let that = this
            that.$message({ message: "密码修改成功", type: "success" });
            setTimeout(() => {
              that.$router.push({
                name: "Login",
                query:{
                  platform: that.platform,
                  role: that.role,
                }
              });
            }, 1500);
          } else {
            this.$message({ message: msg, type: "error" });
          }
        })
        .finally(() => {
          loadingInstance.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
